import { render } from "./DeleteArea.vue?vue&type=template&id=24cb0970"
import script from "./DeleteArea.vue?vue&type=script&lang=js"
export * from "./DeleteArea.vue?vue&type=script&lang=js"

import "./DeleteArea.vue?vue&type=style&index=0&id=24cb0970&lang=css"

import exportComponent from "/home/yandry/Downloads/s3-integration-app-web-prod(1)/s3-integration-app-web-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__